// extracted by mini-css-extract-plugin
export const player = "style-module--player--3aXzc";
export const player__card = "style-module--player__card--30kLs";
export const player__cardFront = "style-module--player__cardFront--3S3lB";
export const player__cardBack = "style-module--player__cardBack--2Ft7o";
export const player__listen = "style-module--player__listen--QH8xq";